import { useState, type CSSProperties, type ReactNode } from "react";
import { useRef } from "react";
import { Row, Col } from "react-bootstrap";
import { Flex } from "../../../../styled-system/jsx";
import { css } from "../../../../styled-system/css";
import { useResizeObserver } from "usehooks-ts";

interface Props {
  title: string;
  initialExpanded?: boolean;
  children?: ReactNode;
  marginTop?: CSSProperties["marginTop"];
  overflow?: string;
  visible?: boolean;
  onExpanded?: (expanded: boolean) => void;
}

const Accordion = ({
  title,
  initialExpanded = false,
  children,
  marginTop = "3rem",
  overflow = "hidden",
  visible = true,
  onExpanded,
}: Props) => {
  const [expanded, setExpanded] = useState(initialExpanded);
  const contentRef = useRef<HTMLDivElement>(null);
  const { height = 0 } = useResizeObserver({ ref: contentRef });

  const handleExpand = (expanded: boolean) => {
    setExpanded(expanded);
    onExpanded?.(expanded);
  };

  if (!visible) return null;

  return (
    <>
      <Flex
        style={{
          marginTop,
        }}
        onClick={() => handleExpand(!expanded)}
        cursor={"pointer"}
        alignItems={"center"}
      >
        <span
          className={css({
            display: "flex",
            flexGrow: 0,
            alignItems: "center",
            marginRight: "2rem",
            color: "text.heading",
            fontSize: "medium",
            fontWeight: "600",
            textTransform: "uppercase",
          })}
        >
          {title}
          <i className={expanded ? "pe-7s-angle-up" : "pe-7s-angle-down"} style={{ fontSize: "2rem" }} />
        </span>
        <div
          className={css({
            flexGrow: 1,
            height: "1px",
            backgroundColor: "lightgrey",
          })}
        ></div>
      </Flex>
      <Row
        style={{
          overflow: expanded ? undefined : overflow,
          maxHeight: expanded ? height + 20 : "0",
          transition: "all 0.3s ease-in-out",
        }}
      >
        <Col xs={12}>
          <div ref={contentRef} style={{ marginTop: "2rem" }}>
            {children}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Accordion;
